type Props = {
  enabled: boolean;
  onChange: (
    value: boolean,
  ) => void;
};

const ProductiveToggle = ({
  enabled,
  onChange,
}: Props) => {
  return (
    <button
      type="button"
      onClick={() =>
        onChange(!enabled)
      }
      className={
        enabled
          ? 'h-[36px] rounded-[8px] px-4 text-[12px] font-medium transition-all bg-[#002B5B] text-white'
          : 'h-[36px] rounded-[8px] px-4 text-[12px] font-medium transition-all border border-[#D0D5DD] bg-white text-[#818B9D]'
      }
    >
      Show Productive Apps Only
    </button>
  );
};

export default ProductiveToggle;